import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const removeProductCartApi = createAsyncThunk(
  "removeProductInCart",
  async (id) => {
    const response = await axiosInstance.delete(`/deleteCartItem/${id}`);
    return response.data;
  }
);

const removeProductCartSlice = createSlice({
  name: "removeProductInCart",
  initialState: {
    data: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(removeProductCartApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeProductCartApi.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(removeProductCartApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default removeProductCartSlice.reducer;
